import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.75 4.5C1.61193 4.5 1.5 4.61193 1.5 4.75V19.25C1.5 19.3881 1.61193 19.5 1.75 19.5H22.25C22.3881 19.5 22.5 19.3881 22.5 19.25V4.75C22.5 4.61193 22.3881 4.5 22.25 4.5H1.75ZM0 4.75C0 3.7835 0.783502 3 1.75 3H22.25C23.2165 3 24 3.7835 24 4.75V19.25C24 20.2165 23.2165 21 22.25 21H1.75C0.783502 21 0 20.2165 0 19.25V4.75Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 15.5842V8.41583C9 8.02025 9.43762 7.78133 9.77038 7.99524L15.3458 11.5794C15.6519 11.7762 15.6519 12.2238 15.3458 12.4206L9.77038 16.0048C9.43762 16.2187 9 15.9798 9 15.5842Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgVideo;
